import { render } from "./VpcTab.vue?vue&type=template&id=6ceedce7&scoped=true"
import script from "./VpcTab.vue?vue&type=script&lang=js"
export * from "./VpcTab.vue?vue&type=script&lang=js"

import "./VpcTab.vue?vue&type=style&index=0&id=6ceedce7&lang=scss&scoped=true"

import exportComponent from "/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ceedce7"]])

export default __exports__